import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import Button from "../ui/Button";
import Container from "../layout/Container";
import { Cal, Pip, Rate, Reel } from "../characters/Character";
import { MiniStar, SoftCircle, Squiggle } from "../characters/Decor";
import { useI18n } from "../../i18n/I18nProvider";

const ease = [0.22, 1, 0.36, 1];

const Hero = () => {
  const { t } = useI18n();
  const reduced = useReducedMotion();
  const words = String(t("hero.title")).split(" ");

  return (
    <section id="top" className="relative flex min-h-[calc(100dvh-5rem)] items-center overflow-hidden">
      <Container className="w-full">
        <div className="relative mx-auto max-w-3xl pt-28 pb-24 md:py-0">
          <div className="pointer-events-none absolute -left-36 -top-4 hidden md:block" aria-hidden="true">
            <SoftCircle className="h-16 w-16" />
          </div>
          <MiniStar className="pointer-events-none absolute -right-10 -top-2 hidden h-7 w-7 md:block" />
          <Squiggle className="pointer-events-none absolute -left-2 bottom-1 hidden w-14 md:block" />
          <motion.div
            className="absolute left-0 top-1 z-20 md:-left-28 md:top-2"
            initial={reduced ? false : { opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: 0.55, ease }}
          >
            <Cal size={84} className="pointer-events-auto md:hidden" />
            <Cal size={108} className="pointer-events-auto hidden md:block" />
          </motion.div>
          <motion.div
            className="absolute right-0 top-1 z-20 md:-right-24 md:top-0"
            initial={reduced ? false : { opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: 0.62, ease }}
          >
            <Reel size={76} className="md:hidden" />
            <Reel size={96} className="hidden md:block" />
          </motion.div>
          <motion.div
            className="absolute bottom-2 left-0 z-20 md:-left-16 md:bottom-0"
            initial={reduced ? false : { opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: 0.7, ease }}
          >
            <Rate size={52} />
          </motion.div>
          <motion.div
            className="absolute bottom-2 right-0 z-20 md:-right-14 md:bottom-0"
            initial={reduced ? false : { opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: 0.78, ease }}
          >
            <Pip size={60} />
          </motion.div>
          <div className="relative z-10 mx-auto max-w-3xl px-4 text-center md:px-6">
          <motion.p
            className="inline-flex rounded-pill bg-lilac px-3 py-1 text-body font-medium text-[#241c3e]"
            initial={reduced ? false : { opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease }}
          >
            {t("hero.badge")}
          </motion.p>
          <h1 className="mt-4 text-heading-lg font-normal tracking-heading-sm text-ink md:text-[64px] md:leading-[1.02] md:tracking-[-1.4px]">
            {words.map((word, index) => (
              <motion.span
                key={`${word}-${index}`}
                className="mr-[0.28em] inline-block"
                initial={reduced ? false : { opacity: 0, y: 24, filter: "blur(6px)" }}
                animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                transition={{ duration: 0.45, delay: 0.08 + index * 0.06, ease }}
              >
                {word}
              </motion.span>
            ))}
          </h1>
          <motion.p
            className="mx-auto mt-5 max-w-2xl text-body text-mid-gray"
            initial={reduced ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: 0.55, ease }}
          >
            {t("hero.body")}
          </motion.p>
          <motion.div
            className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row"
            initial={reduced ? false : { opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.66, ease }}
          >
            <Button href="https://me.influ8.app" arrow className="w-full sm:w-auto">
              {t("hero.app")}
            </Button>
            <Button
              href="https://dashboard.influ8.app"
              variant="outline"
              className="w-full sm:w-auto"
            >
              {t("hero.advertiser")}
            </Button>
          </motion.div>
        </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
